/**
 * Reindirizzamento verso il dominio di un altro prodotto PRIMA che l'app parta.
 *
 * Va importato per primo in main.tsx. Se l'URL appartiene a un prodotto servito da un altro
 * dominio (es. vecchio link app.mindleadsuite.com/construction/… dopo il passaggio), si va lì
 * con l'indirizzo completo — percorso, parametri e #hash — e l'avvio si interrompe: così il
 * client Supabase non legge né consuma i token di accesso o di recupero password nell'URL.
 */
import { placePath } from "./hosts";
import { platform } from "./runtime";

if (typeof window !== "undefined") {
  const placement = placePath(window.location, platform.resolution, platform.env, platform.localPort);
  if (placement.kind === "redirect") {
    window.location.replace(placement.url);
    // Interrompe la valutazione dei moduli successivi (app, client Supabase, Sentry).
    throw new Error(`[mindlead] reindirizzamento a ${placement.product}`);
  }
}

export {};
